<template>
  <div class="ion-page">
    <ion-header>
      <ion-toolbar>
        <ion-title>Main Menu</ion-title>
        <ion-buttons slot="start">
          <ion-back-button href="/"></ion-back-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <ion-grid>
        <ion-row justify-content-center>
          <ion-col align-self-center size="12" size-sm>
            <br />
            <br />
            <div>
              <ion-button
                size="large"
                class="adjust-font-size"
                @click="makeAppointments"
                expand="block"
              >Shot Appointments</ion-button>
            </div>
            <div>
              <ion-button
                size="large"
                class="adjust-font-size"
                @click="cancelAppointments"
                expand="block"
              >Cancel Shot Appointments</ion-button>
            </div>
            <div>
              <ion-button
                size="large"
                class="adjust-font-size"
                @click="viewExistingAppointments"
                expand="block"
              >Existing Shot Appointments</ion-button>
            </div>
            <br />
            <br />
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-content>
    <div id="app">
      <modal v-show="isModalVisible" @close="closeModal" />
    </div>
  </div>
</template>
<script>
import modal from "../../components/modal/modal.vue";
import Repository from "../../repositories/RepositoryFactory";
const AuthorizationRepository = Repository.get("authorization");

export default {
  components: {
    modal
  },
  data() {
    return {
      isModalVisible: false,
      broadcastMessage: ""
    };
  },
  created: async function() {
    var values = this.$route.params.data.split("~");
    // eslint-disable-next-line no-console
    console.log(values);

    var locationInteger = parseInt(values[2], 10);
    this.$store.state.otherLocation = locationInteger;
    this.$store.state.otherUserName = values[1];
    var userIdInteger = parseInt(values[3], 10);
    this.$store.state.otherUserId = userIdInteger;
    var webIdInteger = parseInt(values[2], 10);
    this.$store.state.otherWebId = webIdInteger;
  },
  methods: {
    changePassword() {
      let self = this;
      self.$router.push({ name: "changepassword" });
    },
    addUpdateShotPatients() {
      let self = this;
      self.$router.push({ name: "addupdateshotpatients" });
    },
    makeAppointments() {
      let self = this;
      self.$router.push({ name: "othermakeappointments" });
    },
    cancelAppointments() {
      let self = this;
      self.$router.push({ name: "othercancelappointments" });
    },
    viewExistingAppointments() {
      let self = this;
      self.$router.push({ name: "otherviewexistingappointments" });
    },
    addFamilyAccount() {
      let self = this;
      self.$router.push({ name: "addpatientsscreenone" });
    },
    viewFamilyAccount() {
      let self = this;
      self.$router.push({ name: "otherpatientsscreenone" });
    },
    logout: async function() {
      const result = await AuthorizationRepository.adminlogout();
      if (result.data.status === "Success") {
        let self = this;
        self.$router.push({ name: "home" });
      } else {
        alert("Logout Failed");
      }
    },
    showModal() {
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    }
  }
};
</script>
